export const SEARCH_BY_STORE = "DAILY/SEARCH_BY_STORE";
export const SET_ACTIVE_DAILY_TAB = "DAILY/SET_ACTIVE_DAILY_TAB";
export const SET_SORT_BY_BEST = "DAILY/SET_SORT_BY_BEST";
export const SET_FILTER_BY = "SET_FILTER_BY";
